import "../../resources/less/components/DeviceLimitation.less";
import { UAParser } from "ua-parser-js";
import JQuery from "jquery";
import screenfull from "screenfull";

export default class DeviceRestriction {
  public static readonly MAX_WIDTH = 599;
  public static readonly MAX_HEIGHT = 449;
  private readonly portraitWarning: JQuery<HTMLElement>;
  private readonly mobileRestriction: JQuery<HTMLElement>;
  private readonly smallDeviceRestriction: JQuery<HTMLElement>;
  private readonly isPortraitMandatory: boolean;
  private readonly isLandscapeMandatory: boolean;
  private readonly checkHeight: boolean;
  private readonly isAnonymous: boolean;
  private isRestricted: boolean;
  private parser: UAParser;
  private readonly deviceType: string;
  private isPortrait = false;
  private isLandscape = false;

  constructor() {
    this.portraitWarning = $(".portrait-orientation-warning");
    this.mobileRestriction = $(".mobile-restriction");
    this.smallDeviceRestriction = $(".small-device-restriction");
    this.isPortraitMandatory =
      this.portraitWarning.hasClass("portrait-mandatory");
    this.isLandscapeMandatory = this.portraitWarning.hasClass(
      "landscape-mandatory",
    );
    this.checkHeight = this.smallDeviceRestriction.hasClass("check-height");
    this.isAnonymous = this.portraitWarning.hasClass("is-anonymous");
    this.isRestricted = false;
    this.parser = new UAParser();
    this.deviceType = this.parser.getDevice().type;
    this.checkEnabledDevices();
    this.checkPortrait();
    this.checkSmallDevices();

    $(window).on("resize", () => {
      this.checkPortrait();
      this.checkSmallDevices();
    });
  }

  public static DisplayDeviceRestriction(
    element: JQuery<HTMLElement>,
    isRestricted: boolean,
  ): void {
    element.toggleClass("hide", !isRestricted);
  }

  public static IsIpad(): boolean {
    const parser = new UAParser();
    const osName = parser.getResult().os.name;
    const { model } = parser.getResult().device;
    return (
      (osName === "macOS" && "ontouchend" in document) ||
      (model !== undefined && model.toLowerCase() === "ipad")
    );
  }

  public static IsTablet(): boolean {
    const parser = new UAParser();
    const type = parser.getDevice().withFeatureCheck()["type"];
    return type === "tablet" || type === "mobile" || DeviceRestriction.IsIpad();
  }

  public static IsMobile(): boolean {
    return $("body").hasClass("mobile");
  }

  public static IsTooSmall(checkHeight = false): boolean {
    return (
      window.matchMedia(`(max-width: ${this.MAX_WIDTH}px)`).matches ||
      (checkHeight &&
        window.matchMedia(`(max-height: ${this.MAX_HEIGHT}px)`).matches)
    ); // On some pages, ex: Demo, we also need the page to be high enough
  }

  public static IsMobileSize(): boolean {
    return (
      // This uses the the width for max-height, which is always our largest allowed dimension,
      window.matchMedia(`(max-height: ${this.MAX_WIDTH}px)`).matches ||
      window.matchMedia(`(max-width: ${this.MAX_WIDTH}px)`).matches
    );
  }

  /**
   * On non-mobile, if the viewport is tiny on selected pages, we prefer to display a button to put the page in full screen
   * If the fullscreen isn't enough, we display an appropriate popup
   * @constructor
   */
  public static DisplayMandatoryFullscreen(): void {
    const preferFullscreen = $(".prefer-fullscreen-warning").text() === "1";
    const mandatoryFullscreenElement = $(".troubadour-fullscreen-restriction");
    const tooSmallElement = $(".troubadour-too-small");
    const parser = new UAParser();
    const type = parser.getDevice().type;

    mandatoryFullscreenElement.addClass("hide");
    tooSmallElement.addClass("hide");
    if (!preferFullscreen || !this.IsTooSmall() || type === "mobile") {
      return;
    }
    if (!screenfull.isFullscreen) {
      mandatoryFullscreenElement.removeClass("hide");
    } else {
      tooSmallElement.removeClass("hide");
    }
  }

  private checkPortrait(): void {
    if (this.isRestricted) {
      return;
    }

    this.isPortrait = false;
    this.isLandscape = false;

    if (this.deviceType === "mobile" && this.isPortraitMandatory) {
      this.isLandscape = window.matchMedia("(orientation: landscape)").matches;

      DeviceRestriction.DisplayDeviceRestriction(
        this.portraitWarning,
        this.isLandscape,
      );
    }

    if (this.isLandscapeMandatory) {
      this.isPortrait =
        window.matchMedia("(orientation: portrait)").matches &&
        !window.matchMedia(`(max-width: ${DeviceRestriction.MAX_WIDTH}px)`)
          .matches; //If the device is too small, do not display this warning but the restriction one instead

      DeviceRestriction.DisplayDeviceRestriction(
        this.portraitWarning,
        this.isPortrait,
      );
    }
  }

  private checkSmallDevices(): void {
    const preferFullscreen = $(".prefer-fullscreen-warning").text() === "1";
    if (this.isRestricted || this.isPortrait || preferFullscreen) {
      return;
    }
    DeviceRestriction.DisplayDeviceRestriction(
      this.smallDeviceRestriction,
      DeviceRestriction.IsTooSmall(this.checkHeight),
    );
  }

  private checkEnabledDevices(): void {
    switch (this.deviceType) {
      case "console":
      case "wearable":
      case "embedded":
        this.isRestricted =
          window.matchMedia(`(max-width: ${DeviceRestriction.MAX_WIDTH}px)`)
            .matches ||
          window.matchMedia(`(max-height: ${DeviceRestriction.MAX_HEIGHT}px)`)
            .matches;
        break;
      default:
        this.isRestricted = false;
    }
    DeviceRestriction.DisplayDeviceRestriction(
      this.mobileRestriction,
      this.isRestricted,
    );
  }
}

$(window).on("load", () => {
  new DeviceRestriction();
});
